
// Copyright 2002-2013, University of Colorado Boulder

define( 'AXON/axon',['require'],function( require ) {
  'use strict';

  var axon = {};

  // will be filled in by other modules
  return axon;
} );
